/* eslint-disable camelcase */
import type { Dispensaries_Integrations, Maybe } from 'src/gql/graphql';

export const isLeaflogixIntegrationEnabled = (
  menuType: 'med' | 'rec',
  leaflogixIntegration: Maybe<Array<Maybe<Dispensaries_Integrations>>>
): boolean => {
  const matchingIntegrationForMenuType = leaflogixIntegration?.find(
    (integration) => integration?.integrationType === menuType
  );
  if (matchingIntegrationForMenuType) {
    return true;
  }
  const unifiedIntegration = leaflogixIntegration?.find((integration) => !integration?.integrationType);
  if (unifiedIntegration) {
    return true;
  }
  return false;
};
